// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1HFLt","loaderOuter":"PageOverlayLoader_loaderOuter__h5GFa"};